// extracted by mini-css-extract-plugin
export default {"container":"articles_container__QTZ12","header":"articles_header__s0cz8","desc":"articles_desc__63Lc7","articles":"articles_articles__fmGnW","article":"articles_article__dR8hP"};